export default __webpack_public_path__ + "static/media/early-noon.51cda7dd.jpg";